// This function will sort the countries alphabetically

function sortCountriesAlphabetical(listCountries) {
  const sortedListCountries = listCountries.sort((a, b) => {
    if (a.country < b.country) {
      return -1;
    }
    if (a.country > b.country) {
      return 1;
    }
    return 0;
  });

  return sortedListCountries;
}

export default sortCountriesAlphabetical;
